import { action, fsa } from "ts-action";
import {
  IS_DATA_SOURCES_FETCHING,
  IS_DATA_SOURCES_STATE_FETCHING,
  IS_FETCHING_DATA_SOURCE_STATE,
  RECEIVE_DATA_SOURCE,
  RECEIVE_DATA_SOURCES,
  RECEIVE_DATA_SOURCES_STATE,
  UPDATE_DATA_SOURCE_STATE,
} from "./actionTypes";
import {
  DataSourceModel,
  DataSources,
  DataSourcesState,
  DataSourceState,
} from "../../requests/dataSources/types";

export const receiveDataSources = action(
  RECEIVE_DATA_SOURCES,
  fsa<{
    dataSources: DataSources;
  }>()
);

export const receiveDataSource = action(
  RECEIVE_DATA_SOURCE,
  fsa<{
    dataSource: DataSourceModel;
  }>()
);

export const isDataSourcesFetching = action(
  IS_DATA_SOURCES_FETCHING,
  fsa<{
    flag: boolean;
  }>()
);

export const isDataSourcesStateFetching = action(
  IS_DATA_SOURCES_STATE_FETCHING,
  fsa<{
    flag: boolean;
  }>()
);

export const receiveDataSourcesState = action(
  RECEIVE_DATA_SOURCES_STATE,
  fsa<{
    dataSourcesState: DataSourcesState;
  }>()
);

export const updateDataSourceState = action(
  UPDATE_DATA_SOURCE_STATE,
  fsa<{
    dataSourceState: DataSourceState;
    dataSourceId: number;
  }>()
);

export const isDataSourceStateFetching = action(
  IS_FETCHING_DATA_SOURCE_STATE,
  fsa<{
    dataSourceId: number;
    flag: boolean;
  }>()
);
